export interface Position {
  x?: number;
  y?: number;
}

export const MOVEMENT_INTERVAL = 1200;
export const GROUP_SCREEN_SHARE_SUBSCRIPTION_ID = 'group-screen-share';
export const PARTICIPANT_SCREEN_SHARE_ENDED_MESSAGE = 'The screen share was ended by another event.';
export const PUBLISHER_SCREEN_SHARE_ENDED_MESSAGE = 'Your screen share was ended by another event.';
export const PARTICIPANT_LEFT_GROUP_MESSAGE = 'The screen share session ended because you left the group.';
